var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
var isListResult = function (data) {
    return (typeof data === 'object' &&
        data !== null &&
        data.hasOwnProperty('items') &&
        Array.isArray(data.items) &&
        typeof data.totalCount === 'number');
};
var MemoryProxy = /** @class */ (function () {
    function MemoryProxy(config) {
        this.config = config;
        this.params = {};
    }
    MemoryProxy.prototype.load = function (payload, loadParams, loadFilterQuery) {
        var _this = this;
        var params = __assign(__assign({}, this.params), (loadParams || {}));
        return of(this.dataProvider ? this.dataProvider(params) : null).pipe(map(function (data) {
            if (!data) {
                return {
                    meta: {
                        status: 200
                    },
                    data: null
                };
            }
            var resultData = data;
            if (isListResult(resultData)) {
                resultData = resultData.items;
            }
            return {
                meta: {
                    status: 200
                },
                data: _this.config.mapper(resultData)
            };
        }));
    };
    MemoryProxy.prototype.setContext = function () {
        // no-op
    };
    /**
     * Set data provider
     * @param dataProvider
     */
    MemoryProxy.prototype.setDataProvider = function (dataProvider) {
        this.dataProvider = dataProvider;
    };
    MemoryProxy.prototype.setParams = function (params) {
        this.params = params;
    };
    MemoryProxy.prototype.isEmpty = function (data) {
        return data == null || data === '' || (Array.isArray(data) && !data.length);
    };
    return MemoryProxy;
}());
export { MemoryProxy };
//# sourceMappingURL=MemoryProxy.js.map